var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _path9, _path10, _path11, _path12, _rect4, _rect5, _rect6, _path13, _rect7, _rect8, _rect9, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 353,
    viewBox: "0 0 630 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.442 217.976L337.924 132.031C337.852 130.838 338.61 128.629 342.222 129.345L512.121 129.345C513.868 128.972 518.021 129.524 520.657 134.717L564.101 195.147C565.438 197.012 568.923 200.742 572.16 200.742L628.554 200.742",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.699 218.2L293.183 132.174C293.269 130.979 292.535 128.768 288.911 129.485L118.877 129.485C117.133 129.112 112.971 129.664 110.274 134.863L66.1162 195.364C64.7562 197.231 61.2265 200.966 57.9877 200.966L1.54799 200.966",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.15 316.902L292.11 324.064C292.183 325.108 291.712 327.197 289.237 327.197L219.993 327.197C219.358 327.197 217.62 325.944 215.745 320.931C215.333 319.829 213.396 315.008 210.449 307.726M1.43047 221.781L21.2995 221.781M137.362 189.775L137.342 193.356L137.383 185.97M137.362 189.775L148.605 189.775M137.362 189.775L126.119 189.775M148.605 189.775L159.849 189.775C161.943 189.775 163.404 192.163 163.874 193.356C173.968 218.082 190.411 258.395 202.093 287.135M148.605 189.775L148.585 193.356L148.627 185.97M126.119 189.775L114.876 189.775C113.449 189.626 109.924 190.133 107.241 193.356L96.8203 205.778M126.119 189.775L126.099 193.356L126.14 185.97M96.8203 205.778L86.3996 218.2C85.2031 219.393 82.4295 221.781 80.9066 221.781L61.0375 221.781M96.8203 205.778L107.171 205.778L86.4693 205.778M41.1685 221.781L41.1421 226.481M41.1685 221.781L61.0375 221.781M41.1685 221.781L21.2995 221.781M61.0375 221.781L61.0112 226.481M21.2995 221.781L21.2731 226.481M210.449 307.726L222.006 307.726M210.449 307.726C209.221 304.691 207.817 301.229 206.275 297.43M206.275 297.43L222.063 297.43M206.275 297.43C204.972 294.22 203.571 290.77 202.093 287.135M202.093 287.135L222.121 287.135",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.894 316.902L336.854 324.064C336.769 325.108 337.217 327.197 339.692 327.197L408.936 327.197C409.57 327.197 411.322 325.944 413.254 320.931C413.679 319.829 415.67 315.008 418.699 307.726M628.682 221.781L608.813 221.781M493.11 189.775L493.09 193.356L493.131 185.97M493.11 189.775L481.867 189.775M493.11 189.775L504.353 189.775M481.867 189.775L470.623 189.775C468.529 189.775 467.041 192.163 466.558 193.356C456.186 218.082 439.29 258.395 427.285 287.135M481.867 189.775L481.847 193.356L481.888 185.97M504.353 189.775L515.596 189.775C517.025 189.626 520.544 190.133 523.191 193.356L533.472 205.778M504.353 189.775L504.333 193.356L504.374 185.97M533.472 205.778L543.753 218.2C544.936 219.393 547.683 221.781 549.206 221.781L569.075 221.781M533.472 205.778L523.121 205.778L543.823 205.778M588.944 221.781L588.918 226.481M588.944 221.781L569.075 221.781M588.944 221.781L608.813 221.781M569.075 221.781L569.049 226.481M608.813 221.781L608.787 226.481M418.699 307.726L407.142 307.726M418.699 307.726C419.961 304.691 421.403 301.229 422.988 297.43M422.988 297.43L407.199 297.43M422.988 297.43C424.326 294.22 425.767 290.77 427.285 287.135M427.285 287.135L407.257 287.135",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.64 201.861L316.635 24.6002C316.639 23.8541 317.123 22.362 319.027 22.362L519.145 22.362C521.366 22.4366 525.811 21.8249 525.828 18.781C525.845 15.7371 525.89 7.66487 525.911 4.00923C525.837 3.11397 526.259 1.32346 528.543 1.32346L619.51 0.990965",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.139 201.861L316.134 24.6002C316.138 23.8541 315.671 22.362 313.771 22.362L113.957 22.362C111.739 22.4366 115.312 21.6447 115.329 18.6008C115.346 15.557 115.392 7.48472 115.412 3.82908C115.496 2.93382 107.09 1.32345 104.809 1.32345L11.6 1.14331",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.897 337.717L314.852 345.774C314.682 347.714 315.39 351.593 319.578 351.593L492.57 351.593C493.838 351.742 497.285 350.877 500.928 346.221L557.966 274.153C559.004 272.885 561.509 270.348 563.222 270.348L628.183 270.348",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.906 337.717L313.86 345.774C314.008 347.714 313.257 351.593 309.069 351.593L136.077 351.593C134.807 351.742 131.37 350.877 127.779 346.221L71.5512 274.153C70.5271 272.885 68.0508 270.348 66.3376 270.348L1.37655 270.348",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.707 22.5857)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 3.02539 22.5859)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 291.979 163.528)",
    fill: "url(#paint0_linear_422_3059)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.28354e-10 -0.00561531 0.999984 314.287 147.414)",
    fill: "url(#paint1_linear_422_3059)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.90509,
    height: 14.772,
    transform: "matrix(1 4.36203e-10 -0.00561531 0.999984 336.749 163.528)",
    fill: "url(#paint2_linear_422_3059)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.157 327H289.577C290.401 327.167 292.05 326.8 292.05 324C292.05 321.2 292.05 287.5 292.05 281.5",
    stroke: "url(#paint3_linear_422_3059)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.416 351.5H311.836C312.66 351.667 314.309 351.3 314.309 348.5C314.309 345.7 314.309 312 314.309 306",
    stroke: "url(#paint4_linear_422_3059)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346.956 327H339.536C338.712 327.167 337.063 326.8 337.063 324C337.063 321.2 337.063 287.5 337.063 281.5",
    stroke: "url(#paint5_linear_422_3059)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.202 351.5H316.782C315.958 351.667 314.309 351.3 314.309 348.5C314.309 345.7 314.309 312 314.309 306",
    stroke: "url(#paint6_linear_422_3059)",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 614.08 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 599.315 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.55 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M569.782 193.655C569.784 193.243 570.12 192.909 570.532 192.909L578.74 192.909C579.845 192.909 580.735 193.804 580.729 194.909L580.726 195.559C580.72 196.568 579.898 197.385 578.89 197.385L573.491 197.385C571.431 197.385 569.77 195.715 569.782 193.655Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.834 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.5986 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 46.3633 192.909)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1237 193.655C61.1261 193.243 60.7939 192.909 60.3819 192.909L52.1737 192.909C51.0691 192.909 50.1686 193.804 50.1624 194.909L50.1588 195.559C50.1531 196.568 50.9659 197.385 51.9742 197.385L57.3725 197.385C59.4327 197.385 61.1122 195.715 61.1237 193.655Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_3059",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_3059",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_422_3059",
    x1: 0.952545,
    y1: 0,
    x2: 0.952545,
    y2: 14.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_422_3059",
    x1: 291.556,
    y1: 326.5,
    x2: 301.749,
    y2: 323.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_422_3059",
    x1: 313.814,
    y1: 351,
    x2: 324.008,
    y2: 348.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_422_3059",
    x1: 337.558,
    y1: 326.5,
    x2: 327.364,
    y2: 323.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_422_3059",
    x1: 314.804,
    y1: 351,
    x2: 304.61,
    y2: 348.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame3);
export default __webpack_public_path__ + "static/media/card1-frame3.bd38ab52d44d31095cc6d7b086ec17be.svg";
export { ForwardRef as ReactComponent };